import { startMeasurement, trackUsage } from './metrics';
import { isUsageEvent } from './usage-events';
import { bindCommerce } from './commerce';

startMeasurement();
bindCommerce();
document.querySelectorAll('[data-track]').forEach((link) => {
  link.addEventListener('click', () => {
    const code = link.getAttribute('data-track');
    const event = code === 'consultation-click' ? 'consultation-click-general'
      : code === 'shutdown-audit-start' ? 'guide-shutdown-start' : code;
    if (event && isUsageEvent(event)) trackUsage(event);
  });
});
